import React, { useEffect, useRef, useState } from "react";
import AboutApi1 from "../../api/AboutApi1";
import AgencySvg from "../svg/Agency";
import { NavLink } from "react-router-dom";
import OurMissionApi from "../../api/OurMissionApi";
import img from "../../assets/images/about/values_1.jpg"

const placeholderImageUrl = img

const Values = ({ img, imgStyle }) => {
    const [inView, setInView] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setInView(true);
                        observer.unobserve(entry.target);
                    }
                });
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    const fadeInStyle = {
        opacity: inView ? 1 : 0,
        transition: 'opacity 1s ease-in-out',
    };

    const valuesData = [
        { title: 'Ethics', description: 'Committed to upholding the highest ethical standards and fostering a culture of integrity.', icon: 'las la-shield-alt' },
        { title: 'Integrity', description: 'Prioritizing honesty, transparency, and accountability to build strong relationships.', icon: 'las la-lock' },
        { title: 'Quality', description: 'Delivering excellence and innovation while maintaining stringent quality standards.', icon: 'las la-star' }
    ];

    return (
        <section className="about-section pt-0" style={{ paddingBottom: "25px" }} ref={sectionRef}>
            <div className="container">
                <div className="row align-items-center" style={fadeInStyle}>
                    <div className="col-12 col-lg-6 ps-lg-5 mt-5 mt-lg-0 theme-title">
                        {/* <h2 style={{ textAlign: "left", marginTop: "25px" }}>Our Core Values</h2> */}
                        <p style={{ textAlign: "justify",wordSpacing:"-1px", marginTop: "15px" }}>
                            At Logic Fusion LLC, our core values guide every aspect of our operations. We are committed to upholding these principles in our pursuit of excellence and innovation.
                        </p>
                        <ul style={{ textAlign: "left", marginTop: "15px", paddingLeft: "0", listStyleType: "none" }}>
                            {valuesData.map((value, index) => (
                                <li key={index} style={{ marginBottom: "10px" }}>
                                    <i className="la la-check-circle" style={{ color: "#ff6a00", marginRight: "10px" }}></i>
                                    {value.description}
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="col-12 col-lg-6 position-relative">
                        <img
                            className={`img-fluid rounded-bottom${imgStyle}`}
                            src={placeholderImageUrl}
                            style={{ borderRadius: "25px", height: "450px", width: "100%", objectFit: "cover", padding: "15px" }}
                            alt="Placeholder Image"
                            onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
                            onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                        />
                    </div>

                </div>
            </div>
        </section>
    );
};

export default Values;